/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Delete_ConfirmInputs */

const cs_requirements_delete_confirm = /** @type {(inputs: Requirements_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tuto poptávku?`)
};

const en_requirements_delete_confirm = /** @type {(inputs: Requirements_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this demand?`)
};

/**
* | output |
* | --- |
* | "Delete this demand?" |
*
* @param {Requirements_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_delete_confirm = /** @type {((inputs?: Requirements_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_delete_confirm(inputs)
	return cs_requirements_delete_confirm(inputs)
});